<template>
  <div class="vx-row">
    <vx-card>
      <vs-row vs-w="12" class="mb-10">
        <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12">
          <vs-button icon="keyboard_backspace" @click="goBack">Back</vs-button>
        </vs-col>
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="10" vs-sm="4" vs-xs="12">
          <h3>Review Account Contact Requests - {{ campaignDescription.campaign_name }} </h3>
        </vs-col>
      </vs-row>


      <vs-popup title="Request Account Details" :active.sync="showSAccountDetailsPopup">
        <vs-row vs-w="12" class="mb-5">

          <vs-col vs-lg="12" vs-sm="12" vs-xs="12">

            <div class="p-5">
              <div class="vx-row mb-6" v-if="viewAccountDescription.company_name">
                <div class="vx-col sm:w-1/3 w-full">
                  <span class="font-bold"> Company Name: </span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                  {{ viewAccountDescription.company_name }}
                </div>
              </div>
              <div class="vx-row mb-6" v-if="viewAccountDescription.actual_account_name">
                <div class="vx-col sm:w-1/3 w-full">
                  <span class="font-bold"> Actual Account Name: </span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                  {{ viewAccountDescription.actual_account_name }}
                </div>
              </div>
              <div class="vx-row mb-6" v-if="viewAccountDescription.company_registration_number">
                <div class="vx-col sm:w-1/3 w-full">
                  <span class="font-bold"> Registration Number: </span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                  {{ viewAccountDescription.company_registration_number }}
                </div>
              </div>

              <div class="vx-row mb-6" v-if="viewAccountDescription.status">
                <div class="vx-col sm:w-1/3 w-full">
                  <span class="font-bold"> Company Status: </span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                  {{ viewAccountDescription.status }}
                </div>
              </div>
              <div class="vx-row mb-6" v-if="viewAccountDescription.company_category">
                <div class="vx-col sm:w-1/3 w-full">
                  <span class="font-bold"> Company Category: </span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                  {{ viewAccountDescription.company_category }}
                </div>
              </div>
              <div v-if="
                viewAccountDescription.registered_office_address_1 ||
                viewAccountDescription.registered_office_address_2 ||
                viewAccountDescription.registered_office_address_3 ||
                viewAccountDescription.registered_office_city ||
                viewAccountDescription.registered_office_county ||
                viewAccountDescription.registered_office_country ||
                viewAccountDescription.registered_office_country
              ">
                <vs-divider class="m-5" />
                <!-- Registered Office -->
                <h5 class="mb-5 font-bold">Registered Office Address</h5>
              </div>
              <div class="vx-row mb-6" v-if="viewAccountDescription.registered_office_address_1">
                <div class="vx-col sm:w-1/3 w-full">
                  <span class="font-bold">Address Line 1:</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                  {{ viewAccountDescription.registered_office_address_1 }}
                </div>
              </div>
              <div class="vx-row mb-6" v-if="viewAccountDescription.registered_office_address_2">
                <div class="vx-col sm:w-1/3 w-full">
                  <span class="font-bold"> Address Line 2: </span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                  {{ viewAccountDescription.registered_office_address_2 }}
                </div>
              </div>
              <div class="vx-row mb-6" v-if="viewAccountDescription.registered_office_address_3">
                <div class="vx-col sm:w-1/3 w-full">
                  <span class="font-bold"> Address Line 3:</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                  {{ viewAccountDescription.registered_office_address_3 }}
                </div>
              </div>
              <div class="vx-row mb-6" v-if="viewAccountDescription.registered_office_city">
                <div class="vx-col sm:w-1/3 w-full">
                  <span class="font-bold"> City: </span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                  {{ viewAccountDescription.registered_office_city }}
                </div>
              </div>
              <div class="vx-row mb-6" v-if="viewAccountDescription.registered_office_county">
                <div class="vx-col sm:w-1/3 w-full">
                  <span class="font-bold"> County: </span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                  {{ viewAccountDescription.registered_office_county }}
                </div>
              </div>
              <div class="vx-row mb-6" v-if="viewAccountDescription.registered_office_postcode">
                <div class="vx-col sm:w-1/3 w-full">
                  <span class="font-bold"> Postcode:</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                  {{ viewAccountDescription.registered_office_postcode }}
                </div>
              </div>
              <div class="vx-row mb-6" v-if="viewAccountDescription.registered_office_country">
                <div class="vx-col sm:w-1/3 w-full">
                  <span class="font-bold"> Country:</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                  {{ viewAccountDescription.registered_office_country }}
                </div>
              </div>

              <!-- Head Office -->
              <div v-if="
                viewAccountDescription.head_office_address_1 ||
                viewAccountDescription.head_office_address_2 ||
                viewAccountDescription.head_office_address_3 ||
                viewAccountDescription.head_office_city ||
                viewAccountDescription.head_office_county ||
                viewAccountDescription.head_office_postcode ||
                viewAccountDescription.head_office_country
              ">
                <vs-divider class="m-5" />
                <h5 class="mb-5 font-bold">Head Office Address</h5>
              </div>
              <div class="vx-row mb-6" v-if="viewAccountDescription.head_office_address_1">
                <div class="vx-col sm:w-1/3 w-full">
                  <span class="font-bold"> Address Line 1: </span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                  {{ viewAccountDescription.head_office_address_1 }}
                </div>
              </div>
              <div class="vx-row mb-6" v-if="viewAccountDescription.head_office_address_2">
                <div class="vx-col sm:w-1/3 w-full">
                  <span class="font-bold"> Address Line 2: </span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                  {{ viewAccountDescription.head_office_address_2 }}
                </div>
              </div>
              <div class="vx-row mb-6" v-if="viewAccountDescription.head_office_address_3">
                <div class="vx-col sm:w-1/3 w-full">
                  <span class="font-bold"> Address Line 3: </span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                  {{ viewAccountDescription.head_office_address_3 }}
                </div>
              </div>
              <div class="vx-row mb-6" v-if="viewAccountDescription.head_office_city">
                <div class="vx-col sm:w-1/3 w-full">
                  <span class="font-bold"> City:</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                  {{ viewAccountDescription.head_office_city }}
                </div>
              </div>
              <div class="vx-row mb-6" v-if="viewAccountDescription.head_office_county">
                <div class="vx-col sm:w-1/3 w-full">
                  <span class="font-bold"> County: </span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                  {{ viewAccountDescription.head_office_county }}
                </div>
              </div>
              <div class="vx-row mb-6" v-if="viewAccountDescription.head_office_postcode">
                <div class="vx-col sm:w-1/3 w-full">
                  <span class="font-bold"> Postcode: </span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                  {{ viewAccountDescription.head_office_postcode }}
                </div>
              </div>
              <div class="vx-row mb-6" v-if="viewAccountDescription.head_office_country">
                <div class="vx-col sm:w-1/3 w-full">
                  <span class="font-bold"> Country: </span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                  {{ viewAccountDescription.head_office_country }}
                </div>
              </div>
              <!-- <vs-divider class="m-5" /> -->
              <template v-if="
                viewAccountDescription.web &&
                viewAccountDescription.web.length > 0
              ">
                <div class="vx-row p-5">
                  <h6 class="mr-5 font-bold">Company Website(s)</h6>
                </div>
                <div v-for="(website, web_key) in viewAccountDescription.web" :key="web_key">
                  <span>
                    <p>{{ website.url }}</p>
                  </span>
                </div>
                <vs-divider class="m-5" />
              </template>

              <template v-if="
                viewAccountDescription.linkedin &&
                viewAccountDescription.linkedin.length > 0
              ">
                <div class="vx-row p-5">
                  <h6 class="mr-5 font-bold">Social Media Pages</h6>
                </div>
                <div v-for="(link, linkedin_key) in viewAccountDescription.linkedin" :key="linkedin_key">
                  <span>
                    <p>{{ link.url }}</p>
                  </span>
                </div>
                <vs-divider class="m-5" />
              </template>

              <!-- Site Office -->
              <template v-if="
                viewAccountDescription.satellite_office &&
                viewAccountDescription.satellite_office.length > 0
              ">
                <h5 class="mb-5 font-bold">Site Office Address</h5>
                <template v-for="(site, index) in viewAccountDescription.satellite_office">
                  <div :key="index">
                    <vs-divider class="m-5" />
                    <h6 class="mb-5 font-bold">
                      {{ 'Satellite Office ' + (index + 1) }}
                    </h6>
                    <div class="vx-row mb-6" v-if="site.address_1">
                      <div class="vx-col sm:w-1/3 w-full">
                        <span class="font-bold"> Address Line 1:</span>
                      </div>
                      <div class="vx-col sm:w-2/3 w-full">
                        {{ site.address_1 }}
                      </div>
                    </div>
                    <div class="vx-row mb-6" v-if="site.address_2">
                      <div class="vx-col sm:w-1/3 w-full">
                        <span class="font-bold"> Address Line 2:</span>
                      </div>
                      <div class="vx-col sm:w-2/3 w-full">
                        {{ site.address_2 }}
                      </div>
                    </div>
                    <div class="vx-row mb-6" v-if="site.address_3">
                      <div class="vx-col sm:w-1/3 w-full">
                        <span class="font-bold"> Address Line 3:</span>
                      </div>
                      <div class="vx-col sm:w-2/3 w-full">
                        {{ site.address_3 }}
                      </div>
                    </div>
                    <div class="vx-row mb-6" v-if="site.city">
                      <div class="vx-col sm:w-1/3 w-full">
                        <span class="font-bold"> City:</span>
                      </div>
                      <div class="vx-col sm:w-2/3 w-full">{{ site.city }}</div>
                    </div>
                    <div class="vx-row mb-6" v-if="site.county">
                      <div class="vx-col sm:w-1/3 w-full">
                        <span class="font-bold"> County:</span>
                      </div>
                      <div class="vx-col sm:w-2/3 w-full">{{ site.county }}</div>
                    </div>
                    <div class="vx-row mb-6" v-if="site.postcode">
                      <div class="vx-col sm:w-1/3 w-full">
                        <span class="font-bold"> Postcode:</span>
                      </div>
                      <div class="vx-col sm:w-2/3 w-full">
                        {{ site.postcode }}
                      </div>
                    </div>
                    <div class="vx-row mb-6" v-if="site.country">
                      <div class="vx-col sm:w-1/3 w-full">
                        <span class="font-bold"> Country:</span>
                      </div>
                      <div class="vx-col sm:w-2/3 w-full">{{ site.country }}</div>
                    </div>
                    <div class="vx-row mb-6" v-if="site.phone.length != 0">
                      <div class="vx-col sm:w-1/3 w-full">
                        <span class="font-bold"> Telephone:</span>
                      </div>
                      <div class="vx-col sm:w-2/3 w-full">
                        <template v-for="(phone, key) in site.phone">
                          <div :key="key" v-if="phone.satellite_office_id == site.id">
                            {{ phone.phone_code }} - {{ phone.phone_no }}
                          </div>
                        </template>
                      </div>
                    </div>
                  </div>
                </template>
                <vs-divider class="m-5" />
              </template>

              <!-- Telephone -->
              <template v-if="
                viewAccountDescription.phone &&
                viewAccountDescription.phone.length > 0
              ">
                <div class="vx-row p-5">
                  <h6 class="mr-5 font-bold">Telephone Number(s)</h6>
                </div>
                <div class="vx-row mb-6">
                  <div class="vx-col w-full">
                    <template v-for="phone in viewAccountDescription.phone">
                      <template v-for="p_type in phone.phone_type">
                        <template v-if="phone.id == p_type.phone_id">
                          <!-- <template v-if="p_type.type == 'head_office_switchboard'"> -->
                          <p class="m-2">
                            {{ p_type.type }} : {{ phone.phone_code
                            }}{{ phone.phone_no }}
                            <span v-if="phone.checked_status == 'Registered'" class="tps-registered" style="font-size: 20px" title="TPS Registered">®</span>
                          </p>
                          <!-- </template>
<template v-if="p_type.type == 'customer_service'">
                      <p class="m-10">
                        Customer Service - {{ phone.phone_no }}
                      </p>
                    </template>

<template v-if="p_type.type == 'sales_line'">
                      <p class="m-10">Sales Line - {{ phone.phone_no }}</p>
                    </template>

<template v-if="p_type.type == 'customer_support_line'">
                      <p class="m-10">
                        Customer Support Line - {{ phone.phone_no }}
                      </p>
                    </template> -->
                        </template>
                      </template>
                    </template>
                  </div>
                  <div class="vx-col sm:w-2/3 w-full"></div>
                </div>
              </template>
              <!-- SIC CODE -->
              <template v-if="
                viewAccountDescription.sic_code &&
                viewAccountDescription.sic_code.length > 0
              ">
                <div class="vx-row p-5">
                  <h6 class="mr-5 font-bold">Sic Code(s)</h6>
                </div>
                <div class="vx-row mb-6">
                  <div class="vx-col w-full">
                    <template v-for="sic in viewAccountDescription.sic_code">
                      <p v-if="sic.sic_code_detail">
                        {{ sic.sic_code_detail.code }}
                        {{ ' - ' + sic.sic_code_detail.description }}
                      </p>
                    </template>
                  </div>
                  <div class="vx-col sm:w-2/3 w-full"></div>
                </div>
              </template>
              <template v-if="
                viewAccountDescription.registration_jurisdiction ||
                viewAccountDescription.parent ||
                viewAccountDescription.vertical
              ">
                <h5 class="mb-5">Other Details</h5>
                <div class="vx-row mb-6" v-if="viewAccountDescription.registration_jurisdiction">
                  <div class="vx-col sm:w-1/3 w-full">
                    <span class="font-bold"> Registration Jurisdiction:</span>
                  </div>
                  <div class="vx-col sm:w-2/3 w-full">
                    {{ RegistrationJurisdiction }}
                    <!-- {{ viewAccountDescription.registration_jurisdiction }} -->
                  </div>
                </div>
                <div class="vx-row mb-6" v-if="viewAccountDescription.parent">
                  <div class="vx-col sm:w-1/3 w-full">
                    <span class="font-bold"> Parent:</span>
                  </div>
                  <div class="vx-col sm:w-2/3 w-full">
                    {{ parent_name }}
                  </div>
                </div>
                <div class="vx-row mb-6" v-if="viewAccountDescription.vertical">
                  <div class="vx-col sm:w-1/3 w-full">
                    <span class="font-bold"> Vertical:</span>
                  </div>
                  <div class="vx-col sm:w-2/3 w-full">
                    <!-- {{ viewAccountDescription.vertical }} -->
                    {{ verticalName }}
                  </div>
                </div>
              </template>
              <div class="vx-row mb-6" v-if="viewAccountDescription.revenue">
                <div class="vx-col sm:w-1/3 w-full">
                  <span class="font-bold"> Revenue: </span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                  {{ viewAccountDescription.currency_name }}
                  {{ viewAccountDescription.revenue }}
                </div>
              </div>
              <div class="vx-row mb-6" v-if="viewAccountDescription.no_of_employees">
                <div class="vx-col sm:w-1/3 w-full">
                  <span class="font-bold"> No of Employees: </span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                  {{ viewAccountDescription.no_of_employees }}
                </div>
              </div>
              <div class="vx-row mb-6" v-if="viewAccountDescription.notes">
                <div class="vx-col sm:w-1/3 w-full">
                  <span class="font-bold"> Notes: </span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                  {{ viewAccountDescription.notes }}
                </div>
              </div>


              <div class="text-center">

                <vs-button class="mb-2" @click="closeViewDetails">Submit</vs-button>
              </div>
            </div>

          </vs-col>
        </vs-row>

      </vs-popup>


      <vs-popup title="Request Account Details" :active.sync="showNewRequestAccountDetailsPopup">
        <vs-row vs-w="12" class="mb-5">

          <vs-col vs-lg="12" vs-sm="12" vs-xs="12">

            <div class="p-5">
              <div class="vx-row mb-6" v-if="viewRequestedAccountDescription.company_name">
                <div class="vx-col sm:w-1/3 w-full">
                  <span class="font-bold"> Company Name: </span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                  {{ viewRequestedAccountDescription.company_name }}
                </div>
              </div>
              <div class="vx-row mb-6" v-if="viewRequestedAccountDescription.actual_account_name">
                <div class="vx-col sm:w-1/3 w-full">
                  <span class="font-bold"> Actual Account Name: </span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                  {{ viewRequestedAccountDescription.actual_account_name }}
                </div>
              </div>
              <div class="vx-row mb-6" v-if="viewRequestedAccountDescription.company_registration_number">
                <div class="vx-col sm:w-1/3 w-full">
                  <span class="font-bold"> Registration Number: </span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                  {{ viewRequestedAccountDescription.company_registration_number }}
                </div>
              </div>

              <div class="vx-row mb-6" v-if="viewRequestedAccountDescription.status">
                <div class="vx-col sm:w-1/3 w-full">
                  <span class="font-bold"> Company Status: </span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                  {{ viewRequestedAccountDescription.status }}
                </div>
              </div>
              <div class="vx-row mb-6" v-if="viewRequestedAccountDescription.company_category">
                <div class="vx-col sm:w-1/3 w-full">
                  <span class="font-bold"> Company Category: </span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                  {{ viewRequestedAccountDescription.company_category }}
                </div>
              </div>
              <div v-if="
                viewRequestedAccountDescription.registered_office_address_1 ||
                viewRequestedAccountDescription.registered_office_address_2 ||
                viewRequestedAccountDescription.registered_office_address_3 ||
                viewRequestedAccountDescription.registered_office_city ||
                viewRequestedAccountDescription.registered_office_county ||
                viewRequestedAccountDescription.registered_office_country ||
                viewRequestedAccountDescription.registered_office_country
              ">
                <vs-divider class="m-5" />
                <!-- Registered Office -->
                <h5 class="mb-5 font-bold">Registered Office Address</h5>
              </div>
              <div class="vx-row mb-6" v-if="viewRequestedAccountDescription.registered_office_address_1">
                <div class="vx-col sm:w-1/3 w-full">
                  <span class="font-bold">Address Line 1:</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                  {{ viewRequestedAccountDescription.registered_office_address_1 }}
                </div>
              </div>
              <div class="vx-row mb-6" v-if="viewRequestedAccountDescription.registered_office_address_2">
                <div class="vx-col sm:w-1/3 w-full">
                  <span class="font-bold"> Address Line 2: </span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                  {{ viewRequestedAccountDescription.registered_office_address_2 }}
                </div>
              </div>
              <div class="vx-row mb-6" v-if="viewRequestedAccountDescription.registered_office_address_3">
                <div class="vx-col sm:w-1/3 w-full">
                  <span class="font-bold"> Address Line 3:</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                  {{ viewRequestedAccountDescription.registered_office_address_3 }}
                </div>
              </div>
              <div class="vx-row mb-6" v-if="viewRequestedAccountDescription.registered_office_city">
                <div class="vx-col sm:w-1/3 w-full">
                  <span class="font-bold"> City: </span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                  {{ viewRequestedAccountDescription.registered_office_city }}
                </div>
              </div>
              <div class="vx-row mb-6" v-if="viewRequestedAccountDescription.registered_office_county">
                <div class="vx-col sm:w-1/3 w-full">
                  <span class="font-bold"> County: </span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                  {{ viewRequestedAccountDescription.registered_office_county }}
                </div>
              </div>
              <div class="vx-row mb-6" v-if="viewRequestedAccountDescription.registered_office_postcode">
                <div class="vx-col sm:w-1/3 w-full">
                  <span class="font-bold"> Postcode:</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                  {{ viewRequestedAccountDescription.registered_office_postcode }}
                </div>
              </div>
              <div class="vx-row mb-6" v-if="viewRequestedAccountDescription.registered_office_country">
                <div class="vx-col sm:w-1/3 w-full">
                  <span class="font-bold"> Country:</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                  {{ viewRequestedAccountDescription.registered_office_country }}
                </div>
              </div>

              <!-- Head Office -->
              <div v-if="
                viewRequestedAccountDescription.head_office_address_1 ||
                viewRequestedAccountDescription.head_office_address_2 ||
                viewRequestedAccountDescription.head_office_address_3 ||
                viewRequestedAccountDescription.head_office_city ||
                viewRequestedAccountDescription.head_office_county ||
                viewRequestedAccountDescription.head_office_postcode ||
                viewRequestedAccountDescription.head_office_country
              ">
                <vs-divider class="m-5" />
                <h5 class="mb-5 font-bold">Head Office Address</h5>
              </div>
              <div class="vx-row mb-6" v-if="viewRequestedAccountDescription.head_office_address_1">
                <div class="vx-col sm:w-1/3 w-full">
                  <span class="font-bold"> Address Line 1: </span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                  {{ viewRequestedAccountDescription.head_office_address_1 }}
                </div>
              </div>
              <div class="vx-row mb-6" v-if="viewRequestedAccountDescription.head_office_address_2">
                <div class="vx-col sm:w-1/3 w-full">
                  <span class="font-bold"> Address Line 2: </span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                  {{ viewRequestedAccountDescription.head_office_address_2 }}
                </div>
              </div>
              <div class="vx-row mb-6" v-if="viewRequestedAccountDescription.head_office_address_3">
                <div class="vx-col sm:w-1/3 w-full">
                  <span class="font-bold"> Address Line 3: </span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                  {{ viewRequestedAccountDescription.head_office_address_3 }}
                </div>
              </div>
              <div class="vx-row mb-6" v-if="viewRequestedAccountDescription.head_office_city">
                <div class="vx-col sm:w-1/3 w-full">
                  <span class="font-bold"> City:</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                  {{ viewRequestedAccountDescription.head_office_city }}
                </div>
              </div>
              <div class="vx-row mb-6" v-if="viewRequestedAccountDescription.head_office_county">
                <div class="vx-col sm:w-1/3 w-full">
                  <span class="font-bold"> County: </span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                  {{ viewRequestedAccountDescription.head_office_county }}
                </div>
              </div>
              <div class="vx-row mb-6" v-if="viewRequestedAccountDescription.head_office_postcode">
                <div class="vx-col sm:w-1/3 w-full">
                  <span class="font-bold"> Postcode: </span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                  {{ viewRequestedAccountDescription.head_office_postcode }}
                </div>
              </div>
              <div class="vx-row mb-6" v-if="viewRequestedAccountDescription.head_office_country">
                <div class="vx-col sm:w-1/3 w-full">
                  <span class="font-bold"> Country: </span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                  {{ viewRequestedAccountDescription.head_office_country }}
                </div>
              </div>
              <!-- <vs-divider class="m-5" /> -->
              <template v-if="
                viewRequestedAccountDescription.web &&
                viewRequestedAccountDescription.web.length > 0
              ">
                <div class="vx-row p-5">
                  <h6 class="mr-5 font-bold">Company Website(s)</h6>
                </div>
                <div v-for="(website, web_key) in viewRequestedAccountDescription.web" :key="web_key">
                  <span>
                    <p>{{ website.url }}</p>
                  </span>
                </div>
                <vs-divider class="m-5" />
              </template>

              <template v-if="
                viewRequestedAccountDescription.linkedin &&
                viewRequestedAccountDescription.linkedin.length > 0
              ">
                <div class="vx-row p-5">
                  <h6 class="mr-5 font-bold">Social Media Pages</h6>
                </div>
                <div v-for="(link, linkedin_key) in viewRequestedAccountDescription.linkedin" :key="linkedin_key">
                  <span>
                    <p>{{ link.url }}</p>
                  </span>
                </div>
                <vs-divider class="m-5" />
              </template>

              <!-- Site Office -->
              <!-- <template
              v-if="
                viewRequestedAccountDescription.satellite_office &&
                viewRequestedAccountDescription.satellite_office.length > 0
              "
            >
              <h5 class="mb-5 font-bold">Site Office Address</h5>
              <template
                v-for="(site, index) in viewRequestedAccountDescription.satellite_office"
              >
                <div :key="index">
                  <vs-divider class="m-5" />
                  <h6 class="mb-5 font-bold">
                    {{ 'Satellite Office ' + (index + 1) }}
                  </h6>
                  <div class="vx-row mb-6" v-if="site.address_1">
                    <div class="vx-col sm:w-1/3 w-full">
                      <span class="font-bold"> Address Line 1:</span>
                    </div>
                    <div class="vx-col sm:w-2/3 w-full">
                      {{ site.address_1 }}
                    </div>
                  </div>
                  <div class="vx-row mb-6" v-if="site.address_2">
                    <div class="vx-col sm:w-1/3 w-full">
                      <span class="font-bold"> Address Line 2:</span>
                    </div>
                    <div class="vx-col sm:w-2/3 w-full">
                      {{ site.address_2 }}
                    </div>
                  </div>
                  <div class="vx-row mb-6" v-if="site.address_3">
                    <div class="vx-col sm:w-1/3 w-full">
                      <span class="font-bold"> Address Line 3:</span>
                    </div>
                    <div class="vx-col sm:w-2/3 w-full">
                      {{ site.address_3 }}
                    </div>
                  </div>
                  <div class="vx-row mb-6" v-if="site.city">
                    <div class="vx-col sm:w-1/3 w-full">
                      <span class="font-bold"> City:</span>
                    </div>
                    <div class="vx-col sm:w-2/3 w-full">{{ site.city }}</div>
                  </div>
                  <div class="vx-row mb-6" v-if="site.county">
                    <div class="vx-col sm:w-1/3 w-full">
                      <span class="font-bold"> County:</span>
                    </div>
                    <div class="vx-col sm:w-2/3 w-full">{{ site.county }}</div>
                  </div>
                  <div class="vx-row mb-6" v-if="site.postcode">
                    <div class="vx-col sm:w-1/3 w-full">
                      <span class="font-bold"> Postcode:</span>
                    </div>
                    <div class="vx-col sm:w-2/3 w-full">
                      {{ site.postcode }}
                    </div>
                  </div>
                  <div class="vx-row mb-6" v-if="site.country">
                    <div class="vx-col sm:w-1/3 w-full">
                      <span class="font-bold"> Country:</span>
                    </div>
                    <div class="vx-col sm:w-2/3 w-full">{{ site.country }}</div>
                  </div>
                  <div class="vx-row mb-6" v-if="site.phone.length != 0">
                    <div class="vx-col sm:w-1/3 w-full">
                      <span class="font-bold"> Telephone:</span>
                    </div>
                    <div class="vx-col sm:w-2/3 w-full">
                      <template v-for="(phone, key) in site.phone">
                        <div
                          :key="key"
                          v-if="phone.satellite_office_id == site.id"
                        >
                          {{ phone.phone_code }} - {{ phone.phone_no }}
                        </div>
                      </template>
                    </div>
                  </div>
                </div>
              </template>
              <vs-divider class="m-5" />
            </template> -->

              <!-- Telephone -->
              <!-- <template
              v-if="
                viewRequestedAccountDescription.phone &&
                viewRequestedAccountDescription.phone.length > 0
              "
            >
              <div class="vx-row p-5">
                <h6 class="mr-5 font-bold">Telephone Number(s)</h6>
              </div>
              <div class="vx-row mb-6">
                <div class="vx-col w-full">
                  <template v-for="phone in viewRequestedAccountDescription.phone">
                    <template v-for="p_type in phone.phone_type">
                      <template v-if="phone.id == p_type.phone_id">
                        <p class="m-2">
                          {{ p_type.type }} : {{ phone.phone_code
                          }}{{ phone.phone_no }}
                          <span
                            v-if="phone.checked_status == 'Registered'"
                            style="font-size: 20px"
                            >®</span
                          >
                        </p>
                       
                      </template>
                    </template>
                  </template>
                </div>
                <div class="vx-col sm:w-2/3 w-full"></div>
              </div>
            </template> -->
              <!-- SIC CODE -->
              <!-- <template
              v-if="
                viewRequestedAccountDescription.sic_code &&
                viewRequestedAccountDescription.sic_code.length > 0
              "
            >
              <div class="vx-row p-5">
                <h6 class="mr-5 font-bold">Sic Code(s)</h6>
              </div>
              <div class="vx-row mb-6">
                <div class="vx-col w-full">
                  <template v-for="sic in viewRequestedAccountDescription.sic_code">
                    <p v-if="sic.sic_code_detail">
                      {{ sic.sic_code_detail.code }}
                      {{ ' - ' + sic.sic_code_detail.description }}
                    </p>
                  </template>
                </div>
                <div class="vx-col sm:w-2/3 w-full"></div>
              </div>
            </template> -->
              <template v-if="
                viewRequestedAccountDescription.registration_jurisdiction ||
                viewRequestedAccountDescription.parent ||
                viewRequestedAccountDescription.vertical
              ">
                <h5 class="mb-5">Other Details</h5>
                <div class="vx-row mb-6" v-if="viewRequestedAccountDescription.registration_jurisdiction">
                  <div class="vx-col sm:w-1/3 w-full">
                    <span class="font-bold"> Registration Jurisdiction:</span>
                  </div>
                  <div class="vx-col sm:w-2/3 w-full">
                    {{ viewRequestedAccountDescription.registration_jurisdiction }}
                  </div>
                </div>
                <div class="vx-row mb-6" v-if="viewRequestedAccountDescription.parent">
                  <div class="vx-col sm:w-1/3 w-full">
                    <span class="font-bold"> Parent:</span>
                  </div>
                  <div class="vx-col sm:w-2/3 w-full">
                    {{ viewRequestedAccountDescription.parent_name }}
                  </div>
                </div>
                <div class="vx-row mb-6" v-if="viewRequestedAccountDescription.vertical">
                  <div class="vx-col sm:w-1/3 w-full">
                    <span class="font-bold"> Vertical:</span>
                  </div>
                  <div class="vx-col sm:w-2/3 w-full">
                    <!-- {{ viewRequestedAccountDescription.vertical }} -->
                    {{ viewRequestedAccountDescription.vertical_name }}
                  </div>
                </div>
              </template>
              <div class="vx-row mb-6" v-if="viewRequestedAccountDescription.revenue">
                <div class="vx-col sm:w-1/3 w-full">
                  <span class="font-bold"> Revenue: </span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                  {{ viewRequestedAccountDescription.currency_name }}
                  {{ viewRequestedAccountDescription.revenue }}
                </div>
              </div>
              <div class="vx-row mb-6" v-if="viewRequestedAccountDescription.no_of_employees">
                <div class="vx-col sm:w-1/3 w-full">
                  <span class="font-bold"> No of Employees: </span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                  {{ viewRequestedAccountDescription.no_of_employees }}
                </div>
              </div>
              <div class="vx-row mb-6" v-if="viewRequestedAccountDescription.notes">
                <div class="vx-col sm:w-1/3 w-full">
                  <span class="font-bold"> Notes: </span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                  {{ viewRequestedAccountDescription.notes }}
                </div>
              </div>


              <div class="text-center">

                <vs-button class="mb-2" @click="closeViewDetails">Submit</vs-button>
              </div>
            </div>

          </vs-col>
        </vs-row>

      </vs-popup>

      <vs-popup title="Request Contact Details" :active.sync="showContactDetailsPopup">
        <vs-row vs-w="12" class="mb-5 p-5">


          <vs-col vs-lg="12" vs-sm="12" vs-xs="12">

            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/4 w-full">
                <h5>Title:</h5>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                {{ matchedContactDescription.title }}
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/4 w-full">
                <h5>Forename:</h5>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                {{ matchedContactDescription.forename }}
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/4 w-full">
                <h5>Surname:</h5>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                {{ matchedContactDescription.surname }}
              </div>
            </div>

            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/4 w-full">
                <h5>Job Title:</h5>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                {{
                  matchedContactDescription.job_title != undefined &&
                    matchedContactDescription.job_title.length > 0
                    ? matchedContactDescription.job_title[0].job_title
                    : ''
                }}
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/4 w-full">
                <h5>Seniority:</h5>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                {{
                  matchedContactDescription.seniority != undefined &&
                    matchedContactDescription.seniority.length > 0
                    ? matchedContactDescription.seniority[0].seniority
                    : ''
                }}
              </div>
            </div>

            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/4 w-full">
                <h5>Role:</h5>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                {{
                  matchedContactDescription.role != undefined &&
                    matchedContactDescription.role.length > 0
                    ? matchedContactDescription.role[0].role
                    : ''
                }}
              </div>
            </div>

            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/4 w-full">
                <h5>Sub Role:</h5>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                {{
                  matchedContactDescription.sub_role != undefined &&
                    matchedContactDescription.sub_role.length > 0
                    ? matchedContactDescription.sub_role[0].sub_role
                    : ''
                }}
              </div>
            </div>

            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/6 w-full">
                <h5>Email</h5>
              </div>
            </div>

            <template v-for="(email, index) in matchedContactDescription.emails">
              <div class="vx-row p-2">
                <div class="vx-col sm:w-1/4 w-full">
                  {{ email.email }}
                </div>
              </div>
            </template>

            <vs-divider class="m-5" />

            <div class="vx-row mb-6">
              <div class="vx-col w-full">
                <h5>Social Media Pages</h5>
              </div>
            </div>

            <template v-for="(
social_media, index
              ) in matchedContactDescription.social_medias">
              <div class="vx-row">
                <div class="vx-col w-full">
                  {{ social_media.social_media }}
                  {{ ' - ' + social_media.summary }}
                </div>
              </div>
            </template>

            <vs-divider class="m-5" />

            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/6 w-full">
                <h5>DDI</h5>
              </div>
            </div>

            <template v-for="(ddi, index) in matchedContactDescription.ddis">
              <div class="vx-row p-2">
                <div class="vx-col w-full">
                  {{ ddi.ddi == null ? '' : ddi.ddi_phone_code + ' - '
                  }}{{ ddi.ddi }}
                </div>
              </div>
            </template>

            <vs-divider class="m-5" />

            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/6 w-full">
                <h5>Mobile</h5>
              </div>
              <div class="vx-col w-full"></div>
            </div>

            <template v-for="(mobile, index) in matchedContactDescription.mobiles">
              <div class="vx-row p-2">
                <div class="vx-col w-full">
                  {{
                    mobile.mobile == null
                      ? ''
                      : mobile.mobile_phone_code + ' - '
                  }}{{ mobile.mobile }}
                </div>
              </div>
            </template>


            <div class="text-center">

              <vs-button class="mb-2" @click="closeContactViewDetails">Submit</vs-button>
            </div>
          </vs-col>

        </vs-row>

      </vs-popup>


      <vs-popup title="Request Contact Details" :active.sync="showNewRequestContactDetailsPopup">
        <vs-row vs-w="12" class="mb-5 p-5">


          <vs-col vs-lg="12" vs-sm="12" vs-xs="12">

            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/4 w-full">
                <h5>Title:</h5>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                {{ viewRequestedContactDescription.title }}
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/4 w-full">
                <h5>Forename:</h5>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                {{ viewRequestedContactDescription.forename }}
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/4 w-full">
                <h5>Surname:</h5>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                {{ viewRequestedContactDescription.surname }}
              </div>
            </div>

            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/4 w-full">
                <h5>Job Title:</h5>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                {{
                  viewRequestedContactDescription.job_title
                }}
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/4 w-full">
                <h5>Seniority:</h5>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                {{
                  viewRequestedContactDescription.seniority
                }}
              </div>
            </div>

            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/4 w-full">
                <h5>Role:</h5>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                {{
                  viewRequestedContactDescription.role
                }}
              </div>
            </div>

            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/4 w-full">
                <h5>Sub Role:</h5>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                {{
                  viewRequestedContactDescription.sub_role
                }}
              </div>
            </div>

            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/6 w-full">
                <h5>Email</h5>
              </div>
            </div>

            <template v-for="(email, index) in viewRequestedContactDescription.emails">
              <div class="vx-row p-2">
                <div class="vx-col sm:w-1/4 w-full">
                  {{ email.email }}
                </div>
              </div>
            </template>

            <vs-divider class="m-5" />

            <div class="vx-row mb-6">
              <div class="vx-col w-full">
                <h5>Social Media Pages</h5>
              </div>
            </div>

            <template v-for="(
social_media, index
              ) in viewRequestedContactDescription.social_medias">
              <div class="vx-row">
                <div class="vx-col w-full">
                  {{ social_media.social_media }}
                  {{ ' - ' + social_media.summary }}
                </div>
              </div>
            </template>

            <vs-divider class="m-5" />

            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/6 w-full">
                <h5>DDI</h5>
              </div>
            </div>

            <template v-for="(ddi, index) in viewRequestedContactDescription.ddis">
              <div class="vx-row p-2">
                <div class="vx-col w-full">
                  {{ ddi.ddi == null ? '' : ddi.ddi_phone_code + ' - '
                  }}{{ ddi.ddi }}
                </div>
              </div>
            </template>

            <vs-divider class="m-5" />

            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/6 w-full">
                <h5>Mobile</h5>
              </div>
              <div class="vx-col w-full"></div>
            </div>

            <template v-for="(mobile, index) in viewRequestedContactDescription.mobiles">
              <div class="vx-row p-2">
                <div class="vx-col w-full">
                  {{
                    mobile.mobile == null
                      ? ''
                      : mobile.mobile_phone_code + ' - '
                  }}{{ mobile.mobile }}
                </div>
              </div>
            </template>


            <div class="text-center">

              <vs-button class="mb-2" @click="closeContactViewDetails">Submit</vs-button>
            </div>
          </vs-col>

        </vs-row>



      </vs-popup>


      <template v-for="(changes, k, index) in review_changes">




        <div class="mt-5 mb-5" v-if="changes['type'] == 'account'">

          <div class="text-center mb-5">
            <u>
              <h5> Account </h5>
            </u>
          </div>


          <vs-row>
            <vs-col vs-type="flex" vs-w="3">
              <h6 class="mr-5">Company Name : </h6> <a class="hyperlink_class" @click="viewAccountDetails(changes)">{{
                'company_name' in
                  changes ? changes['company_name'] : changes['company_name'] }}</a>
            </vs-col>
            <vs-col vs-type="flex" vs-w="3">
              <h6 class="mr-5" v-if="changes['registered_office_country']">Registered Office Country : </h6> {{
                changes['registered_office_country'] }}
            </vs-col>


            <vs-col vs-type="flex" vs-w="3">
              <h6 class="mr-5" v-if="changes['sales_devloper_name']">Sales Developer : </h6> {{
                changes['sales_devloper_name'] }}
            </vs-col>



            <vs-col vs-type="flex" vs-w="2">
              <h6 class="mr-5" v-if="changes['created_at']">Requested Date : </h6> {{ changes['created_at'] }}
            </vs-col>

            <vs-col vs-type="flex" vs-w="1">
              <feather-icon @click="reviewerAccountRequestAccepted(changes)" icon="CheckIcon"
                class="accept-button p-5" />
              <feather-icon @click="reviewerAccountRequestRejected(changes)" class="accept-button p-5"
                icon="DeleteIcon" />
            </vs-col>






          </vs-row>


          <vs-row>


            <vs-col vs-type="flex" vs-w="3">
              <h6 class="mr-5" v-if="changes['account_source']"> Source : </h6> {{ changes['account_source'] }}
            </vs-col>

            <vs-col vs-type="flex" vs-w="6">
              <h6 class="mr-5" v-if="changes['reason_for_account_request']">Reason For Request : </h6> {{
                changes['reason_for_account_request'] }}
            </vs-col>









          </vs-row>
        </div>


        <div class="mt-5 mb-5" v-if="changes['type'] == 'contact'">

          <div class="text-center mb-5">
            <u>
              <h5> Contact </h5>
            </u>
          </div>



          <vs-row class="mt-5">

            <vs-row class="">


              <vs-col vs-type="flex" vs-w="3">
                <h6 class="mr-5">Company Name : </h6> <a class="hyperlink_class" @click="viewAccountDetails(changes)">{{
                  'company_name' in
                    changes ? changes['company_name'] : changes['company_name'] }}</a>
              </vs-col>




              <vs-col vs-type="flex" vs-w="3">
                <h6 class="mr-5" v-if="changes['contact_name']">Contact Name : </h6> <a class="hyperlink_class"
                  @click="viewContactDetails(changes)">{{ changes['contact_name'] }}</a>
              </vs-col>

              <vs-col vs-type="flex" vs-w="3">
                <h6 class="mr-5" v-if="changes['job_title']">Job Title : </h6> {{ changes['job_title'] }}
              </vs-col>






              <vs-col vs-type="flex" vs-w="2">
                <h6 class="mr-5" v-if="changes['created_at']">Requested Date : </h6> {{ changes['created_at'] }}
              </vs-col>


              <vs-col vs-type="flex" vs-w="1">
                <feather-icon v-if="changes['account_not_reviewed']" icon="CheckIcon" style=" cursor: not-allowed;
        pointer-events: none;
        color: #c0c0c0;
        background-color: #ffffff;" class=" p-5" />

                <feather-icon v-if="!changes['account_not_reviewed']" @click="reviewerContactRequestAccepted(changes)"
                  icon="CheckIcon" class="accept-button p-5" />




                <feather-icon @click="reviewerContactRequestRejected(changes)" class="accept-button p-5"
                  icon="DeleteIcon" />
              </vs-col>
              




            </vs-row>





            <vs-row class="">

              <vs-col vs-type="flex" vs-w="2">
                <h6 class="mr-5" v-if="changes['sales_devloper_name']">Sales Developer : </h6> {{
                  changes['sales_devloper_name'] }}
              </vs-col>


                <vs-col vs-type="flex" vs-w="4">
              <h6 class="mr-5" v-if="changes['reason_for_contact_request']">Reason For Request : </h6> {{
                changes['reason_for_contact_request'] }}
            </vs-col>

              <vs-col vs-type="flex" vs-w="3">
                <h6 class="mr-5" v-if="changes['contact_name']">Source : </h6>
                <span class="mr-5" v-if="changes['new_contact']">{{ 'New Contact' }}</span>
                <span class="mr-5" v-if="changes['move_contact_to_other_account']">Transfer contact to <a
                    class="hyperlink_class" @click="viewAccountDetails(changes)">{{ changes['company_name']
                    }}</a></span>
                <span class="mr-5" v-if="changes['add_new_contact_to_this_campaign']"> {{ 'Add contact to campaign'
                  }}</span>

                 
                  
              </vs-col>

              <vs-col vs-type="flex" vs-w="3" v-if="changes['move_contact_to_other_account']">
                <h6 class="mr-5">Original Company : </h6> <a class="hyperlink_class"
                  @click="viewAccountDetails(changes)">{{ changes['original_company_name'] }}</a>
              </vs-col>



            </vs-row>













          </vs-row>
        </div>








        <vs-divider class="p-10" />

      </template>

    </vx-card>

  </div>
</template>

<script>
import moduleAccountsManagement from "@/store/accounts-management/moduleAccountsManagement.js";
import defineAbilitiesFor from "@/config/abilities";
import moduleCampaignManagement from "@/store/campaign-management/moduleCampaignManagement.js";
import moduleContactsManagement from '@/store/contacts-management/moduleContactsManagement.js'
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import vSelect from "vue-select";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { quillEditor } from "vue-quill-editor";
import moduleGradeManagement from "@/store/grade-management/moduleGradeManagement.js";
import moduleSDSubStatusManagement from "@/store/sd-sub-status-management/moduleSDSubStatusManagement.js";
import AccountAutocomplete from '@/components/autocomplete/AccountsAutocomplete.vue'
import VueTrumbowyg from 'vue-trumbowyg';
import 'jquery-resizable-dom/dist/jquery-resizable.js';
import 'jquery-resizable-dom/dist/jquery-resizableTableColumns.js';
import moment from 'moment';
import 'trumbowyg/dist/trumbowyg.min.js';
import 'trumbowyg/dist/ui/trumbowyg.min.css';
import 'trumbowyg/dist/plugins/colors/ui/trumbowyg.colors.min.css';
import 'trumbowyg/dist/plugins/table/trumbowyg.table.min.js';
import 'trumbowyg/dist/plugins/table/ui/trumbowyg.table.min.css';
import 'trumbowyg/dist/plugins/fontsize/trumbowyg.fontsize.min.js';
import 'trumbowyg/dist/plugins/upload/trumbowyg.upload.min.js';
import 'trumbowyg/dist/plugins/colors/trumbowyg.colors.min.js'
import 'trumbowyg/dist/plugins/colors/ui/trumbowyg.colors.min.css'
import 'trumbowyg/dist/plugins/pasteimage/trumbowyg.pasteimage.min.js'
import 'trumbowyg/dist/plugins/preformatted/trumbowyg.preformatted.min.js'
import 'trumbowyg/dist/plugins/lineheight/trumbowyg.lineheight.min.js'
import 'trumbowyg/dist/plugins/indent/trumbowyg.indent.min.js'
import 'trumbowyg/dist/plugins/resizimg/trumbowyg.resizimg.js'

export default {
  data: () => ({
    matchedContactDescription: {},
    parent_name: null,
    verticalName: null,
    showNewRequestAccountDetailsPopup: false,
    showNewRequestContactDetailsPopup: false,
    showSAccountDetailsPopup: false,
    showContactDetailsPopup: false,
    viewRequestedContactDescription: {},
    RegistrationJurisdiction: null,
    viewRequestedAccountDescription: {},
    viewAccountDescription: {},
    user_role_id: null,
    sub_statuses: [],
    moment: moment,
    configs: {
      basic: {
        autogrow: true,
        removeformatPasted: true,
        btns: [
          ['strong', 'em'],
          ['superscript', 'subscript'],
          ['fontsize'],
          ['foreColor', 'backColor'],
          ['link'],
          ['justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull'],
          ['horizontalRule'],
          ['removeformat'],
          ['fullscreen']
        ],
        plugins: {
          table: {
            columns: 10,
            rows: 10,

          },
          resizimg: {
            minSize: 64,
            step: 16,
          }

        }
      }
    },
    all_countries: [],
    all_phone_codes: [],
    all_account_status: [],
    all_contact_status: [],
    opportunity_owner_value: null,
    search: '',
    toggle: false,
    campaign_client_contacts: [],
    newCampaignClientContacts: [],
    phoneTypes: [],
    grade_options: [],
    checkedFields: [],
    user_id: null,
    abilities: null,
    selected_campaign: null,
    campaignDescription: [],
    review_changes: null,
    account_contact_details: [],
    selected_account_fields: [],
    selected_account_fields_with_details: [],
    configDateAndTimePicker: {
      enableTime: true,
      dateFormat: "Y-m-d H:i:s",
      enableSeconds: true
    },
    configDateTimePicker: {
      enableTime: false,
      dateFormat: "Y-m-d"
    },
  }),
  components: {
    "v-select": vSelect,
    flatPickr,
    quillEditor,
    VueTrumbowyg,
    moduleSDSubStatusManagement,
    AccountAutocomplete,

  },
  watch: {

  },
  methods: {

    viewContactDetails(contactDetails) {





      if (contactDetails['matched_contact_id'] == 0 || contactDetails['matched_contact_id'] == '') {
        console.log("Matched Contact ID", contactDetails['matched_contact_id'])


        this.viewRequestedContactDescription = {}

        this.$store
          .dispatch('campaignsManagement/fetchContactRequestRecordsByTableId', contactDetails['uuid'])
          .then(res => {


            console.log("Account Contact Request Records", res.data)
            this.viewRequestedContactDescription = res.data

            this.showNewRequestContactDetailsPopup = true

          })
          .catch(err => {
            console.error(err)
          })




      } else {


        let data = {
          account_id: contactDetails.matched_account_id,
          contact_id: contactDetails.matched_contact_id
        }

        this.matchedContactDescription = {}
        this.$store
          .dispatch('contactsManagement/fetchContact', data)
          .then(res => {
            this.matchedContactDescription = res.data
            this.showContactDetailsPopup = true

          })
          .catch(err => {
            console.error(err)
          })
      }





      // let data = {
      //   account_id : contactDetails.matched_account_id,
      //   contact_id : contactDetails.matched_contact_id
      // }


      // this.$store
      //   .dispatch('contactsManagement/fetchContact', data)
      //   .then(res => {

      //     this.matchedContactDescription = res.data
      //     this.showContactDetailsPopup = true
      //   })
      //   .catch(err => {
      //     console.error(err)
      //   })
    },
    closeViewDetails() {
      this.showNewRequestAccountDetailsPopup = false
      this.showNewRequestContactDetailsPopup = false
      this.showSAccountDetailsPopup = false
      this.showContactDetailsPopup = false
    },
    closeContactViewDetails() {
      this.showNewRequestAccountDetailsPopup = false
      this.showNewRequestContactDetailsPopup = false
      this.showSAccountDetailsPopup = false
      this.showContactDetailsPopup = false
    },
    viewAccountDetails(changes) {


      if (changes['matched_account_id'] == 0 || changes['matched_account_id'] == '') {
        console.log("Matched Account ID", changes['matched_account_id'])
        this.viewRequestedAccountDescription = {}

        this.$store
          .dispatch('campaignsManagement/fetchAccountContactRequestRecords', changes['uuid'])
          .then(res => {


            console.log("Account Contact Request Records", res.data)
            this.viewRequestedAccountDescription = res.data
            this.showSAccountDetailsPopup = false
            this.showNewRequestAccountDetailsPopup = true

          })
          .catch(err => {
            console.error(err)
          })




      } else {

        this.viewAccountDescription = {}
        this.$store
          .dispatch('accountsManagement/fetchAccount', changes['matched_account_id'])
          .then(res => {
            this.viewAccountDescription = res.data

            if (this.viewAccountDescription.parent) {
              this.showParentName(this.viewAccountDescription.parent)
            }
            if (this.viewAccountDescription.registration_jurisdiction) {
              this.viewRegistrationJurisdiction(
                this.viewAccountDescription.registration_jurisdiction
              )
            }
            if (this.viewAccountDescription.vertical) {
              this.showVertical(this.viewAccountDescription.vertical)
            }

            this.showSAccountDetailsPopup = true

          })
          .catch(err => {
            console.error(err)
          })
      }





    },
    getParentCompany(inputValue) {
      return this.$store
        .dispatch('accountsManagement/searchAutocomplete', inputValue)
        .then(response => {
          let data = JSON.parse(JSON.parse(JSON.stringify(response.data)))
          let mappedArray = []
          for (const property in data) {
            mappedArray.push({
              id: data[property].uuid,
              name: data[property].company_name
            })
          }
          return mappedArray
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace('/login')
          }
        })
    },

    updateInput(index, val) {
      let self = this
      self.newCampaignClientContacts[index] = [];
      self.campaign_client_contacts.forEach(element => {
        if (element.full_name.includes(val) && val != "") {
          self.newCampaignClientContacts[index].push(element);
        }
      });

      self.toggle = false
      self.toggle = true
      console.log(self.newCampaignClientContacts[index])

    },
    selectResult(index, client_contact, changes) {
      let self = this
      self.search = client_contact.full_name;
      let dataObj = {}
      dataObj.full_name = client_contact.full_name
      dataObj.id = client_contact.uuid
      self.opportunity_owner_value = dataObj

      for (const property in changes) {

        if (changes[property] == "opportunity_owner") {
          changes['field_value'][0] = dataObj
        }
      }

      // console.log(dataObj)

      // this.$refs[index][0].value = self.search



      self.toggle = false

    },
    goToReviewDataChangesDetail(account_id) {
      this.$router.push({
        path: "/quality_control/review_data/account_detail/" + account_id + "/" + this.$route.params.campaignId + "/" + this.$route.params.campaignName
      });
    },
    updatePrimaryMobile(v, changes, field_name) {

      this.review_changes.forEach(function (e) {
        if (e.account_id == changes.account_id && e.field_name == field_name) {

          e.field_value.forEach(function (m) {
            m.is_primary = 'false'

            if (m.mobile == v.mobile) {
              m.is_primary = 'true'
            }
          })



        }
      })
    },
    updatePrimaryDdi(v, changes, field_name) {

      this.review_changes.forEach(function (e) {
        if (e.account_id == changes.account_id && e.field_name == field_name) {

          e.field_value.forEach(function (m) {
            m.is_primary = 'false'

            if (m.ddi == v.ddi) {
              m.is_primary = 'true'
            }
          })



        }
      })
    },
    updatePrimaryEmail(v, changes, field_name) {

      this.review_changes.forEach(function (e) {
        if (e.account_id == changes.account_id && e.field_name == field_name) {

          e.field_value.forEach(function (m) {
            m.is_primary = 'false'

            if (m.email == v.email) {
              m.is_primary = 'true'
            }
          })



        }
      })
    }, updatePrimarySocialMedia(v, changes, field_name) {

      this.review_changes.forEach(function (e) {
        if (e.account_id == changes.account_id && e.field_name == field_name) {

          e.field_value.forEach(function (m) {
            m.is_primary = 'false'

            if (m.social_media == v.social_media) {
              m.is_primary = 'true'
            }
          })



        }
      })
    },
    getPhoneTypes() {
      this.$store
        .dispatch("accountsManagement/getPhoneTypes")
        .then(res => {
          this.phoneTypes = res.data;
          this.phoneTypes = this.phoneTypes.filter(
            item => item.slug != "head_office_switchboard" && item.slug != "site_switchboard"
          );
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        })
    },
    getAllPhoneCodes() {
      let self = this
      this.$store
        .dispatch("accountsManagement/getAllPhoneCodes")
        .then(response => {
          self.all_phone_codes = response.data
          self.all_countries = response.data
          self.all_phone_codes.forEach(function (ele) {
            if (ele.phone_code) {
              ele.name_with_code = ele.phone_code + ' - ' + ele.name_1
            }
            return ele
          })
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        })
    },
    reviewerAccountRequestAccepted(changes) {


      let self = this;
      self.$vs.loading()
      let request_account_data = {};
      request_account_data.table_id = changes['uuid'];
      request_account_data.reviewer_id = self.user_id


      this.$store
        .dispatch("campaignsManagement/reviewerAccountRequestAccepted", request_account_data)
        .then(res => {
          if (res.data.status == "success") {







            this.$vs.notify({
              color: 'success',
              title: 'Request Account & Contact',
              text: res.data.message,
              time: 2000
            })

            setTimeout(() => {
              window.location.reload()
            }, 2000)






          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    reviewerAccountRequestRejected(changes) {
      let self = this;
      self.$vs.loading()

      let request_account_data = {};
      request_account_data.table_id = changes['uuid'];
      request_account_data.reviewer_id = self.user_id

      this.$store
        .dispatch("campaignsManagement/reviewerAccountRequestRejected", request_account_data)
        .then(res => {
          if (res.data.status == "success") {
              this.$vs.notify({
              color: 'success',
              title: 'Request Account & Contact',
              text: res.data.message,
              time: 2000
            })

            setTimeout(() => {
              window.location.reload()
            }, 2000)


          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    reviewerContactRequestAccepted(changes) {




      let self = this;
      self.$vs.loading()

      let request_contact_data = {};
      request_contact_data.table_id = changes['contact_table_id'];
      request_contact_data.reviewer_id = self.user_id
      


      this.$store
        .dispatch("campaignsManagement/reviewerContactRequestAccepted", request_contact_data)
        .then(res => {
          if (res.data.status == "success") {


              this.$vs.notify({
              color: 'success',
              title: 'Request Account & Contact',
              text: res.data.message,
              time: 2000
            })

            setTimeout(() => {
              window.location.reload()
            }, 2000)

          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    reviewerContactRequestRejected(changes) {
      let self = this;
      self.$vs.loading()

      let request_contact_data = {};
      request_contact_data.table_id = changes['contact_table_id'];
      request_contact_data.reviewer_id = self.user_id

      this.$store
        .dispatch("campaignsManagement/reviewerContactRequestRejected", request_contact_data)
        .then(res => {
          if (res.data.status == "success") {
               this.$vs.notify({
              color: 'success',
              title: 'Request Account & Contact',
              text: res.data.message,
              time: 2000
            })

            setTimeout(() => {
              window.location.reload()
            }, 2000)

          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    //   let self = this;
    //   let selected_campaign_id = this.$route.params.campaignId;
    //   self.$store
    //     .dispatch(
    //       "campaignsManagement/getSelectedAccountCoreFields",
    //       selected_campaign_id
    //     )
    //     .then(response => {
    //       // let result = JSON.parse(response.data);
    //       // let selected_core_column = JSON.parse(result[0]['selected_column'])
    //       // self.selected_account_core_fields = selected_core_column
    //       // let new_fields = ['phone_no', 'url', 'url', 'account_status']
    //       // self.selected_account_core_fields = self.selected_account_core_fields.concat(new_fields);


    //       self.selected_account_core_fields = JSON.parse(response.data);

    //     })
    //     .catch(err => {
    //       console.error(err);
    //     });
    // },
    // getSelectedContactCoreFields() {
    //   let self = this;
    //   let selected_campaign_id = this.$route.params.campaignId;
    //   self.$store
    //     .dispatch(
    //       "campaignsManagement/getSelectedContactCoreFields",
    //       selected_campaign_id
    //     )
    //     .then(response => {

    //       console.log(JSON.parse(response.data))

    //       self.selected_contact_core_fields = JSON.parse(response.data)


    //       // let result = JSON.parse(response.data);
    //       // let selected_core_column = JSON.parse(result[0]['selected_column'])
    //       // self.selected_contact_core_fields = selected_core_column
    //       // let new_fields = ['contact_ddi', 'contact_email', 'contact_mobile', 'contact_social_media', 'contact_status']
    //       // self.selected_contact_core_fields = self.selected_contact_core_fields.concat(new_fields);

    //     })
    // },
    getSelectedAccountFields() {
      let self = this;
      let data = {}
      data.id = this.$route.params.campaignId;
      self.$store
        .dispatch(
          "campaignsManagement/getSelectedAccountFields",
          data
        )
        .then(response => {
          let result = JSON.parse(response.data);



          let account_fields = []
          result.forEach(function (ele) {
            let column_id = '_' + ele.uuid.replaceAll('-', '_')
            account_fields.push(column_id)
          })



          self.selected_account_fields = account_fields


          console.log("RSULT", self.selected_account_fields)

        })
        .catch(err => {
          console.log(err)
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        })
    },
    viewRegistrationJurisdiction(countryId) {
      this.$store
        .dispatch('accountsManagement/getCountry', countryId)
        .then(res => {
          this.RegistrationJurisdiction = res.data.name_1
        })
        .catch(err => {
          if (err.response.status === 404) {
            this.accountDescription.parent = true
            return
          }
          console.error(err)
        })
    },




    goToReviewQualityControlPage(data) {
      this.$router.push({
        path: "/quality_control/account_data/" + data.uuid + '/' + btoa(data.campaign_name)
      });
    },
    goToQualityControlAccounts(data) {
      this.$router.push({
        path: "/quality_control/account_data/" + data.uuid + '/' + btoa(data.campaign_name)
      });
      // console.log(data)
      // this.$router.replace("/sales-developer-dashboard/view/" + this.selected_campaign.campaign_id + '/' + btoa(this.selected_campaign.campaign_name));
      //  alert("got to")
    },
    goToQualityControlContacts(data) {
      this.$router.push({
        path: "/quality_control/contact_data/" + data.uuid + '/' + btoa(data.campaign_name)
      });

      // this.$router.replace("/sales-developer-dashboard/view/" + this.selected_campaign.campaign_id + '/' + btoa(this.selected_campaign.campaign_name));
      //  alert("got to")
    },
    getCampaignDescription() {
      const campaignId = this.$route.params.campaignId;
      this.$store
        .dispatch("campaignsManagement/fetchCampaign", campaignId)
        .then(res => {
          this.campaignDescription = res.data;
        })
        .catch(err => {
          if (err.response.status === 404) {
            this.campaignDescription = true;
            return;
          }
          console.error(err);
        });
    },
    getCampaignAccountContactRequestReviewChanges() {
      let self = this
      let data = {}

      this.$vs.loading()

      data.campaign_id = this.$route.params.campaignId
      data.campaign_name = atob(this.$route.params.campaignName)
      this.$store
        .dispatch("campaignsManagement/getCampaignAccountContactRequestReviewChanges", data)
        .then(res => {

          this.review_changes = res.data;




          self.$vs.loading.close()


          console.log("REVIEW CHANGES", this.review_changes)






        })
        .catch(err => {
          console.error(err);
        });
    },
    firstLast(arr) {
      if (arr.length < 2) return arr;
      return [arr[0], arr[arr.length - 1]];
    },
    goBack: function () {
      this.$router.go(-1);
    }
  },
  beforeMount() {
  },
  mounted() {
    this.getPhoneTypes()
    this.getCampaignDescription()
    this.getCampaignAccountContactRequestReviewChanges()
    this.getAllPhoneCodes()

  },
  created() {
    var self = this;
    defineAbilitiesFor().then(function (data) {
      self.abilities = data;
    });
    let userInfo = JSON.parse(localStorage.getItem("userInfo"));
    self.user_id = userInfo["uid"];
    self.user_role_id = 'affbe5ee-3fe7-4cdb-837a-908592475006' // userInfo['role_id']
    if (!moduleCampaignManagement.isRegistered) {
      this.$store.registerModule(
        "campaignsManagement",
        moduleCampaignManagement
      );
      moduleCampaignManagement.isRegistered = true;
    }


    if (!moduleAccountsManagement.isRegistered) {
      this.$store.registerModule(
        "accountsManagement",
        moduleAccountsManagement
      );
      moduleAccountsManagement.isRegistered = true;
    }

    if (!moduleSDSubStatusManagement.isRegistered) {
      this.$store.registerModule("SDSubStatusManagement", moduleSDSubStatusManagement);
      moduleSDSubStatusManagement.isRegistered = true;
    }

    if (!moduleContactsManagement.isRegistered) {
      this.$store.registerModule('contactsManagement', moduleContactsManagement)
      moduleContactsManagement.isRegistered = true
    }


    if (!moduleGradeManagement.isRegistered) {
      this.$store.registerModule("GradesManagement", moduleGradeManagement);
      moduleGradeManagement.isRegistered = true;
    }
  }
};
</script>
<style scoped>
.social_media_radio {
  width: auto;
}

.vs-table--tbody-table tr {
  -webkit-transition: none;
  transition: none;
  background: #fff;
}

.vs-table--tbody-table .tr-values:not(.activeEdit):not(.tr-expandedx):not(.hoverFlat):hover {
  -webkit-transform: none;
  transform: none;
}

.vs-con-table .vs-con-tbody .vs-table--tbody-table .tr-values .vs-table--td {
  padding: 15px 15px;
}

.vs-con-table .vs-con-tbody .vs-table--tbody-table .vs-table--thead th {
  padding: 25px 15px;
  font-weight: 600;
  font-size: 14px;
}

.vs-con-table .vs-con-tbody .vs-table--tbody-table .vs-table--thead th {
  width: 325px !important;
}

.searchbox {
  margin-left: 5px;
  width: 600px;
}

.filter {
  width: 300px;
}

.pointer {
  cursor: pointer;
}

.item.expanded {
  background-color: white !important;
  color: black !important;
}


.tr-table-state-primary,
.vs-table-primary .is-selected {
  background: none !important;
  box-shadow: none !important;
}

.tr-table-state-primary,
.vs-table-primary .is-selected {
  color: #626262 !important;
  -webkit-box-shadow: 0 0 1px 0 rgba(var(--vs-primary), 1) !important;
  box-shadow: 0 0 1px 0 rgba(var(--vs-primary), 1) !important;
}

.accept-button {
  cursor: pointer;
}

.address_th {
  padding: 30px;
}

.address_td {
  padding: 30px;
  font-weight: 500;
}

.width_class {
  /* max-width: 400px; */
  width: 300px;
}

.imput_field {
  width: 500px;
}

.hyperlink_class {
  cursor: pointer;
}

.vs-input-class {
  width: 100%;
  border: 1px solid rgba(0, 0, 0, 0.2);
  font-size: 1rem;
  height: 38px;
  padding-left: 10px;
  padding-right: -10px;
  border-radius: 4px;
  background: transparent;
  transition: all .2s ease;


}



.dropdown_class {
  border: 1px solid transparent;
  margin: 4px 0 0 0;
  padding: 0 7px;
  background: none;
  box-shadow: none;
  width: 500px;
  background: none;
  border: 1px solid rgba(60, 60, 60, 0.26);
  border-radius: 4px;
  position: relative;
  font-family: inherit;
  height: 35px;
}

.ql-class {
  width: auto;
}

#text_box {
  display: none;
}
</style>

<style lang="stylus">
.inputx
  margin-left 20px
  margin-top 10px



.con-expand-Fields
  .con-btns-Fields
    display flex
    padding 10px
    padding-bottom 0px
    align-items center
    justify-content space-between
    .con-Fieldsx
      display flex
      align-items center
      justify-content flex-start
  .list-icon
    i
      font-size .9rem !important
</style>
